import React, { Fragment } from 'react';

export const About = () => {
  return (
    <Fragment>
      <h1>About This App</h1>
      <p>App to search Github Users</p>
      <p>Version 1.0.0</p>
    </Fragment>
  );
};
